import { DataBaseTemplate } from "@nocios/presentation-kit";
import LastPage from "src/Component/LastPage";
import Config from "src/Constants/Config";
import CustomCenterContentPage6 from "src/Pages/CustomCenterContentPage6";

const PageId = 6;

const DATA = (): DataBaseTemplate => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  return {
    title: "OTHER USE CASES",
    showHeader: true,
    bgVideo: {
      poster: `${baseImageBG}BG_1.jpg`,
      video: `${Config.BASE_URL}/videos/bg_1.mp4`,
    },
    gradient:
      "linear-gradient(270deg, rgba(21, 50, 121, 0.00) 11.77%, #153279 87.81%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%)",
    children: (
      <CustomCenterContentPage6 pageId={PageId}>
        <LastPage />
      </CustomCenterContentPage6>
    ),
  };
};

export default DATA;
